import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { SCREEN_PART_DEFINITION_CONFIG } from './base/screen-part-definition-config';

/**
 * 파트 정의 전용 라우팅
 * list/detail은 screen-part의 컴포넌트를 재사용하고 definition config만 주입.
 */
export const screenPartDefinitionRoutes: Routes = [
  {
    path: SCREEN_PART_DEFINITION_CONFIG.routePath,
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            '../screen-part/components/smart/screen-part-list-page/screen-part-list-page.component'
          ).then((m) => m.ScreenPartListPageComponent),
        data: {
          screenPartKey: 'definition',
          config: SCREEN_PART_DEFINITION_CONFIG,
          title: 'brandFn.menu.partDefinition',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                '../screen-part/components/smart/screen-part-detail-page/screen-part-detail-page.component'
              ).then((m) => m.ScreenPartDetailPageComponent),
            data: {
              screenPartKey: 'definition',
              config: SCREEN_PART_DEFINITION_CONFIG,
              title: '프리셋 정의 상세',
            },
          },
        ],
      },
    ],
  },
];
